import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { detectDevice, getCurrentSurvey } from '../Utlils';
import { DeviceRestrictionPage } from './DeviceNotSupported';

const getAllowedDevices = (deviceType = {}) =>
  Object.keys(deviceType).filter((key) => deviceType[key] === true);

const EncryptStart = () => {
  const [deviceRestriction, setDeviceRestriction] = useState(null);
  const { surveyId, encSupplierId, orgId } = useParams();
  const isMounted = useRef(false);
  const currentDeviceType = detectDevice();
  const urlSearchParams = new URLSearchParams(window.location.search);

  // console.log('currentDeviceType=>', currentDeviceType);
  // console.log("t#01");
  // console.log(r, t, tk, p, org, source_id, utm_id);
  // console.log(surveyId, encSupplierId);

  useEffect(() => {
    isMounted.current = true;

    const { r, t, tk, p, org, source_id, utm_id } = Object.fromEntries(
      urlSearchParams.entries(),
    );

    const isDeviceAllowed = (deviceType) => {
      if (!deviceType) return true;
      return deviceType[currentDeviceType] === true;
    };

    const extraParams =
      `${p ? `&p=${p}` : ''}${org ? `&org=${org}` : ''}` +
      `${source_id ? `&source_id=${source_id}` : ''}${utm_id ? `&utm_id=${utm_id}` : ''}`;

    const start = async () => {
      try {
        const survey = await getCurrentSurvey(surveyId);
        if (!isMounted.current) return;
        if (survey === undefined) {
          console.log('survey not found');
          return;
        }

        const base = `${window.location.origin}/DIY/${survey._id}/${encSupplierId}/${orgId}/lightningStart?SRCID=${encSupplierId}&RID=${tk ? tk : r}`;
        const isTest =
          String(t) === '1' ||
          String(t).toLowerCase() === 'true' ||
          (tk ? tk : r) === 'xxxxx';

        if (!isTest) {
          if (!isDeviceAllowed(survey.deviceType)) {
            setDeviceRestriction({
              allowed: getAllowedDevices(survey.deviceType),
              url: window.location.href,
            });
            return;
          }
          // if (orgId === "u5Ea5JK84TlLXLkSuMx5JYqIS") {
          //   // console.log("inside lucid session count ");
          //   await axios
          //     .get(`${BASE_URL}/session/lucid-session-count/${orgId}`)
          //     .then((res) => {
          //       let { data: lucidCountRes } = res;
          //       // console.log(
          //       //   "got response from api=>",
          //       //   res,
          //       //   lucidCountRes?.success,
          //       //   lucidCountRes?.redirect
          //       // );
          //       if (lucidCountRes?.success && !lucidCountRes?.redirect) {
          //         window.location.href = `${window.location.origin}/error/429`;
          //         return;
          //       }
          //     });
          // }
          window.location.href = `${base}${extraParams}`;
        } else {
          window.location.href = `${base}&gamma=alpha${extraParams}`;
        }
      } catch (err) {
        console.log('something went wrong in url', err);
      }
    };

    start();

    return () => {
      isMounted.current = false;
    };
  }, [surveyId, encSupplierId, orgId]);
  if (deviceRestriction) {
    return (
      <DeviceRestrictionPage
        allowed={deviceRestriction.allowed}
        url={deviceRestriction.url}
      />
    );
  }
  return (
    <div className="flex items-center justify-center h-screen">
      <h1>Loading...</h1>
    </div>
  );
};

export default EncryptStart;
